let serviceList;
let services;
function onDocumentReady() {
    serviceList = $('#core-service-list');
    services = serviceList.find('.services');
    services.click(function() {
        let scrollTo = $(this).data('title');
        $('html, body').animate({
          scrollTop: $('#'+scrollTo).offset().top - 40
        }, 1000);
        return false;
    });
}


$(onDocumentReady);



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/scroll-controller.js